import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["buttons", "label"];

  connect() {
    // Hide buttons initially
    if (this.hasButtonsTarget && this.hasLabelTarget) {
      this.buttonsTarget.classList.add("hidden");
      this.labelTarget.classList.remove("hidden");
    }
  }

  showButtons(event) {
    event.preventDefault();
    if (this.hasButtonsTarget && this.hasLabelTarget) {
      this.labelTarget.classList.add("hidden");
      this.buttonsTarget.classList.remove("hidden");
    }
  }

  hideButtons(event) {
    if (event.relatedTarget && this.element.contains(event.relatedTarget)) {
      return;
    }
    if (this.hasButtonsTarget && this.hasLabelTarget) {
      this.labelTarget.classList.remove("hidden");
      this.buttonsTarget.classList.add("hidden");
    }
  }
}
